export type OptionalUsername = {
	displayName?: string;
	name?: string;
};

export const mapExternalUserToFullName = (userAccount: OptionalUsername): string | undefined =>
	userAccount && (userAccount?.displayName || userAccount?.name);
